import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Field } from 'formik'

import { WithTheme } from '../../../setup/index'
import { transition } from '../../../common/Mixins'
import media from '../../../common/MediaQueries'
import { ContactFormFieldStyledProps } from './types'

const labelTextStyles = css`
  font-size: 0.75rem;
  color: #707070;
  font-weight: 500;
  font-family: 'Montserrat', system-ui, 'sans-serif';
  @media ${media.phone} {
    font-size: 0.875rem;
  }
`

export const ContactFormLabelStyled = styled.label<WithTheme>`
  ${transition}
  ${labelTextStyles}
position: absolute;
  left: 1rem;
  top: 0.75rem;
  padding: 0 0.25rem;
`

const fieldStyles = css`
  height: 2.625rem;
  border: 1px solid #c1c1c1;
  border-radius: 0.5rem;
  width: 100%;
  padding: 0.5rem 1.25rem;
  ${transition}
  &:focus {
    outline: 0;
    border-color: #717171;
    & ~ ${ContactFormLabelStyled} {
      top: -5px;
      font-size: 0.625rem;
      color: #c1c1c1;
      background-color: white;
    }
  }
`

export const ContactFormInputStyled = styled(Field)`
  ${fieldStyles}
  ${labelTextStyles}
`

export const ContactFormPhoneInputStyled = styled.input`
  ${fieldStyles}
  ${labelTextStyles}
`

export const ContactFormButtonStyled = styled.button`
  margin-left: auto;
  margin-right: auto;
`

export const ContactFormTextareaStyled = styled(Field)`
  ${fieldStyles}
  ${labelTextStyles}
  height: 8.25rem;
  font-family: ${({ theme }) => theme.fonts.primary};
`

export const ContactFormSelectStyled = styled(Field)`
  ${fieldStyles}
  ${labelTextStyles}
`

export const ContactFormFieldStyled = styled.div<WithTheme<ContactFormFieldStyledProps>>`
  position: relative;
  margin-bottom: 1.25rem;
  width: 100%;

  ${({ isActive, theme }) =>
    isActive &&
    css`
      ${ContactFormLabelStyled} {
        top: -0.3125rem;
        font-size: 0.625rem;
        color: ${theme.colors.gray2};
        background-color: ${theme.colors.white};
      }
    `}

  ${({ isHalf }) =>
    isHalf &&
    css`
      @media ${media.tablet} {
        width: calc(50% - 0.5rem);
      }
    `}

  ${({ isSmall }) =>
    isSmall &&
    css`
      ${ContactFormInputStyled}, ${ContactFormPhoneInputStyled} {
        padding-left: 2rem;
      }
      &::before {
        ${labelTextStyles}
        position: absolute;
        content: '+';
        top: 0.875rem;
        left: 1.25rem;
      }
      width: 4.5rem;
      @media ${media.tablet} {
        width: 6.75rem;
        margin-right: 0.5rem;
      }
    `}

  ${({ isBig }) =>
    isBig &&
    css`
      width: calc(100% - 1rem - 4.5rem);
      @media ${media.tablet} {
        width: calc(100% - 1rem - 6.75rem);
      }
    `}

  ${({ isPhone }) =>
    isPhone &&
    css`
      ${ContactFormLabelStyled} {
        left: 3.75rem;
      }
    `}
`
export const ContactFormErrorStyled = styled.div<WithTheme>`
  color: ${({ theme }) => theme.colors.red};
  font-size: 0.6875rem;
`
